import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { of, tap } from 'rxjs';
import { CloneAttachments } from 'src/app/job/models/job-attachments-clone.modet';
import { Events } from 'src/app/shared/constants/events.constant';
import {
  EditImage,
  EditImageResponse,
} from 'src/app/shared/models/edit-image.model';
import { FileUploadResponse } from 'src/app/shared/models/file-upload-response.model';
import { Attachment } from 'src/app/shared/models/uploaded-file-list.model';
import { BaseService } from '../base/base.service';
import { EventService } from '../event.service';


@Injectable({
  providedIn: 'root',
})
export class JobAttachmentsService extends BaseService {
  private _jobAttachmentUploadUrl = '/maintenance/api/job-attachment/upload';
  private _jobImageEditUploadUrl = '/maintenance/api/job-attachment/edit-image';
  private _jobAttachmentCloneUrl = '/maintenance/api/job-attachment/clone';

  constructor(http: HttpClient, private eventService: EventService) {
    super(http);
  }

  upload(file: any) {
    return this.post<FileUploadResponse>(this._jobAttachmentUploadUrl, file);
  }

  editImage(imageDetails: EditImage,isFromJobEdit:boolean = false) {
    let endpointUrl = `${this._jobImageEditUploadUrl}?jobId=${imageDetails.jobId}`;
    
    return this.post<EditImageResponse>(endpointUrl, imageDetails.file).pipe(
      tap(() => {
        if(!isFromJobEdit){
          this.eventService.dispatch(Events.JobAttachmentEditEvent);
        }
      })
    );
  }

  clone(cloneAttachments: CloneAttachments) {
    if (cloneAttachments.attachments.length == 0) return of([]);
    return this.post<any>(this._jobAttachmentCloneUrl, cloneAttachments);
  }
}
